import React, { useState, useEffect, useRef } from 'react';
import Scroller from 'ui-component/Scroller';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import StatusBadge from 'ui-component/StatusBadge';
import { TbDatabaseExclamation } from 'react-icons/tb';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { IdentifyIcon, RepairsIcon } from 'ui-component/custom-icons/icons';
import { toast } from 'react-hot-toast';
import { Checkbox, Tooltip, Skeleton } from '@mui/material';
import GradingModalMobile from '../modals/GradingModalMobile';
import RepairModalMobile from '../modals/RepariModalMobile';
import ProductDetailModalMobile from '../modals/ProductDetailModalMobile';

// ✅ Clear
const QualityControlListMobile = ({
    operationDetails,
    handleReloadData,
    handleShowCheckboxAction,
    handleOpenGradingModal,
    handleCloseGradingModal,
    handleGetSelectedItems
}) => {
    const topSection = useRef(null);
    const [gradingModalStatus, setGradingModalStatus] = useState(false);
    const [showRepairPopup, setShowRepairPopup] = useState(false);
    const [showDeleteRepairPopup, setShowDeleteShowRepairPopup] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [inboundList, setInboundList] = useState([]);
    const [productIndexRepair, setProductIndexRepair] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRepair, setSelectedRepair] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDataLoading, setIsDataLoading] = useState(true);

    useEffect(() => {
        updateInboundList();
    }, [operationDetails]);

    useEffect(() => {
        setGradingModalStatus(handleOpenGradingModal);
    }, [handleOpenGradingModal]);

    const updateInboundList = () => {
        const collection = operationDetails?.products?.map(product => ({
            id: product?.id,
            oldGradeId: product?.old_grade_id,
            oldGradeName: product?.old_grade_name,
            newGradeId: product?.new_grade_id,
            newGradeName: product?.new_grade_name,
            colorId: product?.color_id,
            colorName: product?.color_name,
            imei: product?.imei,
            productId: product?.product_id,
            productName: product?.product_name,
            quantity: product?.quantity,
            repairs: product?.repairs,
            isChecked: false,
            status: product?.status,
            comment: product?.comment,
            hasComment: product?.has_comment,
            showComment: false
        })) || [];
        setInboundList(collection);
        setTimeout(() => {
            setIsDataLoading(false);
        }, 1000);
    };

    const handleClose = () => {
        setShowRepairPopup(false);
        setShowDetails(false);
        handleCloseGradingModal(true);
    };
    const handleCloseDeleteRepair = () => {
        setShowDeleteShowRepairPopup(false);
    };

    const handleShowDetails = (item) => {
        setShowDetails(true);
        setSelectedItem(item);
    };


    const addRepair = (index, item) => {
        setShowRepairPopup(true);
        setProductIndexRepair(index);
        setSelectedItem(item);
    };

    const handleAddRepairs = (repairs) => {
        toast.promise(
            api
                .createOperationItemRepair(operationDetails?.id, {
                    operation_item_id: repairs?.operationItemId,
                    assigned_id: repairs?.assignedId,
                    cost: repairs?.repairCost,
                    currency: repairs?.repairCurrency,
                    repair_type_id: repairs?.repairTypeId,
                })
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData();
                        }
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Adding repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to add repair</b>
            }
        );
    };

    const handleDeleteRepair = (index, repair, details) => {
        setShowDeleteShowRepairPopup(true);
        setSelectedRepair(repair);
        setSelectedProduct(details);
    };

    const deleteRepair = () => {
        toast.promise(
            api
                .deleteOperationItemRepair(selectedRepair?.id)
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData();
                            setShowDeleteShowRepairPopup(false);
                            setSelectedRepair(null);
                            setSelectedProduct(null);

                            const updatedRepairs = selectedProduct?.repairs.filter(
                                (r) => r.id !== selectedRepair?.id
                            );
                            setSelectedItem((prevProduct) => ({
                                ...prevProduct,
                                repairs: updatedRepairs,
                            }));
                        }
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Deleting repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to remove repair</b>
            }
        );
    };

    const handleItemCheck = (index) => {
        const newList = [...inboundList];
        newList[index].isChecked = !newList[index].isChecked;
        setInboundList(newList);
        handleGetSelectedItems(newList.filter(item => item.isChecked));
    };

    const areAnyItemsChecked = () => {
        const bool = inboundList.some(item => item.isChecked);
        handleShowCheckboxAction(bool);
        return bool;
    };


    const handleProcessGrading = (items) => {
        toast.promise(
            api
                .setOperationItemGrade(operationDetails?.id, items)
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData();
                            handleCloseGradingModal(true);
                        }
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Adding repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to add repair</b>
            }
        );
    };

    return (
        <>
            <div>
                <div className="bg-white pt-0">
                    <div style={{ borderBottom: '1px solid #eee', width: '100%' }}>
                        <h5>Products</h5>
                    </div>
                    <Scroller extraHeight={topSection?.current?.clientHeight || 0}>
                        {isDataLoading && inboundList.length < 1 ? (
                            [...Array(10)].map((_, i) => (
                                <div
                                    key={i}
                                    style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #eee' }}
                                >
                                    {[...Array(5)].map((_, j) => (
                                        <div key={j} style={{ flex: 1 }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} />
                                        </div>
                                    ))}
                                </div>
                            ))
                        ) : inboundList.length > 0 ? (
                            inboundList.map((item, index) => (
                                <div
                                    key={index}
                                    className="qc-mobile-row"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        padding: '12px 0',
                                        borderBottom: '1px solid #eee',
                                        background: '#fff'
                                    }}
                                >
                                    {operationDetails?.isCompleted !== 1 && (
                                        <PermissionAllowed permissions={['Operations Item Grading']}>
                                            <td className="align-middle">
                                                <Checkbox
                                                    style={{ padding: '5px', paddingLeft: 0 }}
                                                    checked={item.isChecked || false}
                                                    onChange={() => handleItemCheck(index)}
                                                />
                                            </td>
                                        </PermissionAllowed>
                                    )}
                                    <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }} onClick={() => handleShowDetails(item)}>
                                        <div style={{ fontWeight: 500 }}>{item.imei ? item.imei : 'No IMEI'}</div>
                                        <div style={{ fontSize: 13, color: '#444', marginTop: 2 }}>{item.productName}</div>
                                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                                            Grade: {item?.oldGradeName || '-'} | Repairs: {item?.repairs?.length} | Color: {item.colorName && item?.colorName}
                                        </div>
                                    </div>
                                    <div
                                        style={{ flex: 1, minWidth: 0, textAlign: 'center', cursor: 'pointer' }}
                                        onClick={() => handleShowDetails(item)}
                                    ></div>

                                    <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 10, width: 80 }}>
                                        <StatusBadge itemStatus={item?.status} />

                                        <PermissionAllowed permissions={['Add Operations Repairs']}>
                                            <div style={{ flexShrink: 0 }}>
                                                <div
                                                    className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
                                                    style={{ minWidth: 'unset' }}
                                                    onClick={() => addRepair(index, item)}
                                                >
                                                    <RepairsIcon height={'18px'} width={'18px'} />
                                                </div>
                                            </div>
                                        </PermissionAllowed>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="not-found-container cstm-not-found" style={{ height: '385px' }}>
                                <div className="not-found-icon">
                                    <TbDatabaseExclamation />
                                </div>
                                <h6 className="not-found-text">No Products Inbounded</h6>
                            </div>
                        )}
                    </Scroller>
                    <PermissionAllowed permissions={['Operations Item Grading']}>
                        <div className="row d-none" style={{ marginBottom: '10px' }}>
                            <div className="col-1">
                                <div className="d-flex justify-content-start">
                                    <Tooltip title={'Identify Grading'} arrow placement="top">
                                        <button
                                            style={{ marginBottom: '-5px' }}
                                            className="btn btn-primary btn-outlined-main white-var btn-icon-only btn-icon-square"
                                            
                                            disabled={!areAnyItemsChecked()}
                                        >
                                            <IdentifyIcon width={'16px'} height={'16px'} />
                                        </button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </PermissionAllowed>
                </div>
            </div>
            {showRepairPopup && (
                <RepairModalMobile
                    openPopup={showRepairPopup}
                    selectedItem={selectedItem}
                    index={productIndexRepair}
                    handleClose={handleClose}
                    handleAddRepairs={handleAddRepairs}
                />
            )}
            {gradingModalStatus && (
                <GradingModalMobile
                    openPopup={gradingModalStatus}
                    details={inboundList}
                    handleClose={handleClose}
                    handleProcessGrading={handleProcessGrading}
                />
            )}
            {showDetails && (
                <ProductDetailModalMobile
                    openPopup={showDetails}
                    details={selectedItem}
                    handleClose={handleClose}
                    handleDeleteRepair={handleDeleteRepair}
                />
            )}
            {showDeleteRepairPopup && (
                <DeleteConfirmation
                    show={showDeleteRepairPopup}
                    handleClose={handleCloseDeleteRepair}
                    handleDelete={deleteRepair}
                    title="Confirm"
                    message={`Are you sure you want to delete ${selectedRepair?.repair_type?.name} from the repair list?`}
                />
            )}
        </>
    );
};

export default QualityControlListMobile;
